import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Homepage from "./components/Homepage";
import Navbar from "./components/Navbar";
import Academia from "./components/Academia";
import Music from "./components/Music";
import Software from "./components/Software";
import Games from "./components/Games";
import Contact from "./components/Contact";
import Garden from "./components/Garden";
import GardenIndex from "./components/GardenIndex";
import GardenNote from "./components/GardenNote";
import NotFound from "./components/NotFound";
import ThemeToggle from "./components/ThemeToggle";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar></Navbar>
        <ThemeToggle></ThemeToggle>
        <Routes>
          <Route path="/" element={<Homepage />}></Route>
          <Route path="/music" element={<Music />}></Route>
          <Route path="/software" element={<Software />}></Route>
          <Route path="/games" element={<Games />}></Route>
          <Route path="/academia" element={<Academia />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/garden" element={<Garden />}></Route>
          <Route path="/garden/index" element={<GardenIndex />}></Route>
          <Route path="/garden/note/:slug" element={<GardenNote />}></Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </Router>

      <Footer></Footer>
    </div>
  );
}

export default App;
